import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminNewsletterConfigsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('newsletter-config');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model, {
      recordExplorerModelName: 'artist',
    });
  }
}
